import { Variant } from './types/typography.types'

export { default } from './Typography'
export { Variant }
